import {ISlide} from '../../incase-domain/slide';
import {HIGHLIGHTED_ELEMENT_INITIAL} from '../../ui/pages/PresEditPage/PresentationEditPage';
import {
    SET_CONTEXT_SELECTED_ELEMENT_INDEX,
    SET_EMITTED_SLIDE_ACTION,
    SET_HIGHLIGHTED_ELEMENT_INDEX,
    SET_IS_SLIDE_MODIFIED_ACTION,
    SET_IS_SLIDE_MODIFIED_DURING_UPDATE_ACTION,
    SET_SELECTED_ELEMENT_ID,
    UPDATE_SCALE,
    UPDATE_SELECTED_SLIDE,
    UPDATE_SLIDES_WITHOUT_ELEMENTS_ACTION,
} from '../actions/slide';
import {SlideReducerType} from '../actions/types/slide.types';

export interface SlideReducerState {
    selectedSlide: ISlide;
    selectedSlideIndex: number;
    scale: number;
    isSlideSaving: boolean;
    isSlideModified: boolean;
    isSlideModifiedDuringUpdate: boolean;
    emittedSlide: ISlide;
    highlightedElementIndex: number;
    selectedElementId?: string;
    contextSelectedElementIndex: number | null;
}

export const preloadedState = {
    selectedSlide: {
        _id: '',
        name: '',
        slideBackground: '',
        slideMobileBackground: '',
        elements: [],
        appliedRules: [],
        width: '1360',
        height: '760',
        hidden: false,
        favorite: false,
    },
    selectedSlideIndex: 0,
    selectedSlideLayers: [],
    scale: 1,
    isSlideSaving: false,
    isSlideModified: false,
    isSlideModifiedDuringUpdate: false,
    emittedSlide: {
        _id: '',
        name: '',
        slideBackground: '',
        slideMobileBackground: '',
        elements: [],
        appliedRules: [],
        width: '1360',
        height: '760',
        hidden: false,
        favorite: false,
    },
    highlightedElementIndex: HIGHLIGHTED_ELEMENT_INITIAL,
    selectedElementId: undefined,
    contextSelectedElementIndex: null,
};

export const slideReducer = (state: SlideReducerState = preloadedState, action: SlideReducerType): SlideReducerState => {
    switch (action.type) {
        case UPDATE_SELECTED_SLIDE:
            return {
                ...state,
                selectedSlide: action.slide,
                selectedSlideIndex: action.slideIndex,
                isSlideModified: action.isModified,
                isSlideSaving: false,
            };
        case UPDATE_SCALE:
            return {...state, scale: action.scale};
        case UPDATE_SLIDES_WITHOUT_ELEMENTS_ACTION:
            return {...state, isSlideSaving: true};
        case SET_IS_SLIDE_MODIFIED_ACTION:
            return {...state, isSlideModified: action.isModified};
        case SET_IS_SLIDE_MODIFIED_DURING_UPDATE_ACTION:
            return {...state, isSlideModifiedDuringUpdate: action.isModifiedDuringUpdate};
        case SET_EMITTED_SLIDE_ACTION:
            return {...state, emittedSlide: action.emittedSlide};
        case SET_HIGHLIGHTED_ELEMENT_INDEX:
            return {...state, highlightedElementIndex: action.highlightedElementIndex};
        case SET_SELECTED_ELEMENT_ID:
            return {...state, selectedElementId: action.payload};
        case SET_CONTEXT_SELECTED_ELEMENT_INDEX:
            return {...state, contextSelectedElementIndex: action.contextSelectedElementIndex};
        default:
            return state;
    }
};
